import { z } from 'zod';
import { INSTRUMENT_TYPE } from '@fortem-monorepo/constants';
import { baseStructuredSchema } from './shared/base-structured.schema';
import { knockdownInputLevelSchema } from './shared/knockdown-input-level.schema';
export const supertrackerSchema = baseStructuredSchema.extend({
    instrument_type: z.literal(INSTRUMENT_TYPE.Supertracker),
    participation_rate: z.number(),
    knockdown_input_level: knockdownInputLevelSchema,
});
